import { Box, Button, Link, Sheet, Table, Typography } from "@mui/joy";
import useAddEntryForm from "../../hooks/useAddEntryForm";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useLocation } from "react-router-dom";

const AttachmentTable = ({ formData, isReadOnly, handleFileChange, handleFileClick, btsNo }) => {
  const { sectionHeaderStyles, onUploadedFileClick } = useAddEntryForm();
  const location = useLocation();
  const urls = location?.pathname?.split("/");
  const isView = urls?.includes("view-invoice-entry");
  const isGEMInvoiceVisible = formData?.gem_type === "GEM";

  return (
    <>
      <Sheet variant="outlined" sx={{ p: 0, borderRadius: "sm", overflow: "hidden" }}>
        {btsNo !== 11 && (
          <Typography level="title-lg" sx={sectionHeaderStyles} className="heading-1">
            Invoice
          </Typography>
        )}
        <Box sx={{ overflowX: "auto" }}>
          <Table
            borderAxis="bothBetween"
            stickyHeader
            sx={{
              "& tr > *:not(:first-child)": { textAlign: "center" },
            }}
          >
            <tbody>
              <tr>
                <td>
                  {btsNo !== 11 && <Typography level="body-sm">Invoice</Typography>}
                  <Typography level="body-xs" sx={{ mt: 1, color: "text.secondary" }}>
                    Max File Size (5 MB). Only PDF files are accepted.
                  </Typography>
                  <Typography level="body-xs" sx={{ color: "text.secondary" }}>
                    Special character is not allowed in name of scanned sign copy in PDF form.
                  </Typography>
                </td>
                <td style={{ justifyContent: "center", alignItems: "center", minHeight: "max-content" }}>
                  {!isReadOnly ? (
                    <Button component="label" sx={{ maxWidth: "fit-content" }} variant="outlined" size="sm" startDecorator={<CloudUploadIcon />}>
                      Choose File
                      <input type="file" name="attachment" hidden onChange={handleFileChange} accept="application/pdf" />
                    </Button>
                  ) : (
                    <Typography level="body-xs" textColor="text.tertiary">
                      {formData.existingAttachmentName ?? (formData.attachment instanceof File ? "New file selected" : "Not provided")}
                    </Typography>
                  )}
                  {formData.attachment instanceof File && (
                    <Link onClick={() => onUploadedFileClick(formData?.attachmentPreview)} level="body-xs" sx={{ mt: 0.5, display: "block" }}>
                      {formData?.attachment?.name}
                    </Link>
                  )}
                </td>
                <td>
                  {formData.existingAttachmentName ? (
                    <Link onClick={() => handleFileClick("Inv", btsNo)} level="body-sm" sx={{ cursor: "pointer", mx: "auto" }}>
                      View/Download
                    </Link>
                  ) : (
                    <Typography level="body-xs" textColor="text.tertiary">
                      No File uploaded
                    </Typography>
                  )}
                </td>
              </tr>
              {isView && isGEMInvoiceVisible && (
                <tr>
                  <td>{btsNo !== 11 && <Typography level="body-sm">GEM Document</Typography>}</td>
                  <td style={{ justifyContent: "center", alignItems: "center", minHeight: "max-content" }}>
                    <Typography level="body-xs" textColor="text.tertiary">
                      {formData?.gem_attachment_name || "Not provided"}
                    </Typography>
                  </td>
                  <td>
                    {formData?.gem_attachment_name ? (
                      <Link onClick={() => handleFileClick("Tax", btsNo)} level="body-sm" sx={{ cursor: "pointer", mx: "auto" }}>
                        View/Download
                      </Link>
                    ) : (
                      <Typography level="body-xs" textColor="text.tertiary">
                        No File uploaded
                      </Typography>
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Box>
      </Sheet>
    </>
  );
};

export default AttachmentTable;
